import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleMatInward, updateMatInwardEntry } from '../../Store/PHPSlice/MatInward';


const MatInwardEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        matInwId: parseInt(Id),
        matId: '',
        materialNm: '',
        inwardNo: '',
        desp: '',
        size: '',
        pkt: '',
        pktqty: '',
        newpktqty: '',
        stkQty: '',
        newQty: '',
        inwardNo: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singelMatinward = useSelector((state) => state.MatInwardData.singleMatInward || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleMatInward(Id))
    }, [dispatch, Id]);
    useEffect(() => {
        if (singelMatinward.data.length > 0) {
            const item = singelMatinward.data[0];
            setFormData({
                ...formData,
                dt: item.dt,
                matId: item.matId,
                inwardNo: item.inwardNo,
                materialNm: item.materialNm,
                desp: item.description,
                size: item.size,
                pkt: item.pkt,
                pktqty: item.packetqty,
                newpktqty: item.packetqty,
                stkQty: item.qty,
                newQty: item.qty
            });
        }
    }, [singelMatinward]);
    // console.log(singelMatinward)
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;

    //     setFormData({
    //         ...formData,
    //         [name]: value.toUpperCase()
    //     });
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        // convert to number safely
        const numericValue = value.replace(/[^0-9.]/g, '');
        // 👉 Only apply numeric filter for numeric fields
        if (name !== 'inwardNo') {
            newValue = value.replace(/[^0-9.]/g, '');
        }

        setFormData((prevData) => {
            const updated = {
                ...prevData,
                [name]: newValue, // update changed field
            };

            // ✅ Auto-calculate newQty if pkt or pktqty changes
            if (name === 'pkt' || name === 'newpktqty') {
                const perPkt = parseFloat(name === 'pkt' ? numericValue : updated.pkt) || 0;
                const pktQty = parseFloat(name === 'newpktqty' ? numericValue : updated.newpktqty) || 0;
                updated.newQty = perPkt * pktQty;
            }
            if (name === 'newQty' || name === 'stkQty') {
                const perPkt = parseFloat(name === 'pkt' ? numericValue : updated.pkt) || 0;
                const tQty = parseFloat(name === 'newQty' ? numericValue : updated.newQty) || 0;
                updated.newpktqty = tQty / perPkt;
            }


            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(updateMatInwardEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Material Inward Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Material Inward Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'InwardNo', name: 'inwardNo' },
                                    { label: 'Material', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Per Packet Qty', name: 'pkt' },
                                    { label: 'Packet Qty', name: 'pktqty' },
                                    { label: 'New Packet Qty', name: 'newpktqty' },
                                    { label: 'Inward Qty', name: 'stkQty' },
                                    { label: 'New Inward Qty', name: 'newQty' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{
                                                                style: styled.input,
                                                                readOnly: !(field.name === 'newpktqty' || field.name === 'inwardNo' || field.name === 'newQty'),
                                                            }} sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MatInwardEdit;
